import { withTheme } from '@mui/styles';
import styled from 'styled-components';

const VideoJsStyle = withTheme(styled.div`
  width: 100%;
  height: 100%;
  position: relative;

  .video-js {
    width: 100%;
    height: 100%;
    font-size: 16px;
    .vjs-button {
      outline: none;
    }
    .vjs-tech {
      position: relative;
    }
    .vjs-current-time,
    .vjs-time-divider,
    .vjs-duration {
      display: block;
    }
    .vjs-quality-control {
      .vjs-menu li {
        text-transform: none;
      }
    }
    .vjs-playback-rate .vjs-playback-rate-value {
      display: flex;
      font-size: 1em;
      width: 100%;
      justify-content: center;
      align-items: center;
    }

    .vjs-progress-control-container {
      position: relative;
      display: flex;
      flex: auto;
    }

    .vjs-marker-container {
      position: absolute;
      left: 10px;
      right: 10px;
      top: 0;
    }

    .vjs-volume-panel-active .vjs-volume-control {
      visibility: visible;
      left: -3.5em;
      opacity: 1;
      transition: none;
    }

    .vjs-progress-control:hover .vjs-progress-holder {
      font-size: 1.3em;
    }

    &.vjs-user-inactive:not(.vjs-paused),
    &:not(.vjs-has-started) {
      .vjs-button.vjs-custom-menu {
        opacity: 0;
        pointer-events: none;
        transition: opacity 1s ease;
      }

      .vjs-interactive-button {
        transform: translateX(-50%) translateY(3em);
        transition: transform 0s 1s linear;
      }
    }

    .vjs-control-bar {
      ${({ theme }) => theme.breakpoints.down('lg')} {
        font-size: 14px;
      }

      ${({ theme }) => theme.breakpoints.down('md')} {
        font-size: 12px;
      }

      ${({ theme }) => theme.breakpoints.down('sm')} {
        font-size: 10px;
      }
    }
  }
`);

export default VideoJsStyle;
